export enum AuthActionType {
    UPDATE_SETTING = 'UPDATE_SETTING',
}
